import firebase from '../firebase/FirebaseConfig';

// รอ user login เสร็จแล้วคืน Firebase ID token
// ใช้แนบ header Authorization: Bearer <token> เวลาเรียก dataApiSecure (แทน test_api เดิมที่ไม่มี auth)
export async function getIdToken() {
  let user = firebase.auth().currentUser;
  if (!user) {
    user = await new Promise((resolve) => {
      const unsubscribe = firebase.auth().onAuthStateChanged((u) => {
        if (u) {
          unsubscribe();
          resolve(u);
        }
      });
    });
  }
  return user.getIdToken();
}
